import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const GET_LEGAL_STATEMENT = gql`
  query GetLegalStatement($legalStatement: LegalStatementInput!) {
    getLegalStatement(legalStatement: $legalStatement) {
      consentedSuppliersHash
      consentedLegalStatementHash
      suppliersModal
      statement
      newsletters {
        newsletter
        statement
      }
      supplierLegalStatements {
        singleSupplierStatement
        singleSupplierConsentedLegalStatementHash
        multipleSupplierStatement
        multipleSupplierConsentedLegalStatementHash
      }
    }
  }
`;

/**
 * Apollo request
 */
const getLegalStatementQuery = async ({ variables }) => {
  try {
    const statement = await query({
      query: GET_LEGAL_STATEMENT,
      variables,
    });

    return statement.data.getLegalStatement;
  } catch (error) {
    throw new Error('Could not get a Legal Statement');
  }
};

export default getLegalStatementQuery;
